import styled from 'styled-components';
import { COLORS, FONTS, SIZE } from '@app/src/ui';
import { PreviewPrint } from '@app/src/common/PreviewPrint';

interface Props {
  color: string;
}

export const Wrapper = styled.div`
  svg {
    margin-left: 4px;
  }
`;

export const Action = styled.a`
  font-family: ${FONTS.ROBOTO};
  font-size: 13px;
  color: ${(props:Props) => props.color};
  display: flex;
  align-items: center;
`;

export const ModalTitle = styled.div`
  width: 300px;
  height: 60px;
  font-family: ${FONTS.MONTSERRAT};
  font-size: 20px;
  color: ${COLORS.BLACK};
  display: flex;
  align-items: flex-end;
  justify-content: center;
`;

export const ModalContent = styled.div`
  padding: 16px;
  font-size: 12px;
  font-family: ${FONTS.ROBOTO};
`;

export const Strong = styled.strong`
  font-family: ${FONTS.ROBOTO};
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  display: block;
  width: 100%;
`;

export const Preview = styled(PreviewPrint)`
  width: 250px;
  min-height: 75px;
  margin: 5px 0 12px 0;
`;

export const Notice = styled.ul`
  padding:0;
  width: 250px;
  font-family: ${FONTS.ROBOTO};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  color: ${COLORS.GRAY_TEXT};
  padding-left: 20px;
  li{
    list-style: disc;
  }
`;

export const ActionText = styled.span`
  text-decoration: underline;
  font-size: 11px;

  @media(min-width: ${SIZE.TABLET_LANDSCAPE}) {
    font-size: 13px;
  }
`;